import { worldViewerWindow } from '../const';
export class CHeliNetworkCallback {
    OnChangedMicPermissionState(MicPermissionState) {
        worldViewerWindow.hel_postMessage(worldViewerWindow.ETextParamType_OnChangedMicPermissionState, MicPermissionState.toString());
    }
}
